<ion-header [translucent]="true">
  <ion-toolbar class="toolbar-with-closing-button !px-2 md:!px-4">
    <div slot="start" class="hidden md:flex">
      <dojo-icon-button (click)="closeModal()" [icon]="'times'"></dojo-icon-button>
    </div>
    <div slot="end" class="hidden md:flex md:w-8"></div>
    <ion-title class="common-ion-title">Page versions</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="h-full p-4">
    <dojo-master-list-view
      [searchPlaceholder]="'Search page versions'"
      [messages]="messages"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
    />
  </div>
</ion-content>
